var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-table__body"},_vm._l((_setup.props?.dado?.itens),function(item){return _c(_setup.LinhaDeItem,{key:item.id,attrs:{"dado":_setup.props?.dado,"item":item},on:{"update:alteraItem":_setup.alteraItem}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }